import { getPackageTrips } from "./getPackageTrips.js";
const formatTripMessageContent = (trip)=>{
    if (!trip) return '';
    const contents = [
        'Need help with this'
    ];
    if ('PACKAGE' === trip.type) {
        const pkgTrip = getPackageTrips(trip);
        contents.push(`${pkgTrip.pkgType || 'package'} reservation.`);
        if (pkgTrip.title) contents.push(`In ${pkgTrip.title}`);
        if (pkgTrip.dateHeader) contents.push(`during ${pkgTrip.dateHeader}.`);
    } else {
        if ('DRIVE' === trip.type) contents.push('car reservation.');
        if ('FLY' === trip.type) contents.push('flight reservation.');
        if ('STAY' === trip.type) contents.push('hotel reservation.');
        if (trip.title) contents.push(`In ${trip.title}`);
        if (trip.dateHeader) contents.push(`during ${trip.dateHeader}.`);
    }
    return contents.join(' ');
};
export { formatTripMessageContent };
